import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { AppCommonModule } from '../app-common/app-common.module';
import { UIElementsModule } from '../ui-elements/ui-elements.module';
import { allComponents, publicComponents } from './components/index';
import { AuthenticationRoutingModule } from './routing/authentication-routing.module';
import { AuthenticationStoreModule } from './store/authentication-store.module';

@NgModule({
  declarations: [...allComponents],
  imports: [
    AppCommonModule,
    AuthenticationStoreModule,
    AuthenticationRoutingModule,
    DialogModule,
    RouterModule,
    UIElementsModule,
  ],
  exports: [...publicComponents],
})
export class AuthenticationModule {}
